import { render, staticRenderFns } from "./SlickCarousel.vue?vue&type=template&id=4e43652f&scoped=true&"
import script from "./SlickCarousel.vue?vue&type=script&lang=js&"
export * from "./SlickCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SlickCarousel.vue?vue&type=style&index=0&id=4e43652f&prod&lang=scss&scoped=true&"
import style1 from "./SlickCarousel.vue?vue&type=style&index=1&id=4e43652f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e43652f",
  null
  
)

export default component.exports